import { defineStore } from "pinia";
import { computed, Ref } from "vue";
import { useLocalStorage } from "@vueuse/core";
import { LoginRoutesConst } from "src/const/routesConst";
import { TDisorder } from "src/types/const";

type SettingType = {
  locale: string;
  darkMode: boolean;
  currentDType: TDisorder; // dysarthria, aphasia
};

export const useSettingStore = defineStore("setting", () => {
  const setting: Ref<SettingType> = useLocalStorage(
    `stc_${process.env.VUE_APP_ENV}/setting`,
    {
      locale: "",
      darkMode: false,
      currentDType: "D", // default, custom
    }
  );
  localStorage.getItem("test");

  const getSetting = computed(() => {
    return setting.value;
  });

  const getDType = computed(() => {
    return setting.value.currentDType;
  });

  const getDTypeCode = computed(() => {
    return setting.value.currentDType === "A" ? 20 : 10;
  });

  const getPatientPageRouterName = computed(() => {
    return setting.value.currentDType === "A"
      ? LoginRoutesConst.PatientA
      : LoginRoutesConst.PatientD;
  });

  function setSetting(newSetting: Partial<SettingType>) {
    setting.value = { ...setting.value, ...newSetting };
  }

  return {
    setting,
    setSetting,
    getSetting,
    getDTypeCode,
    getDType,
    getPatientPageRouterName,
  };
});
